import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';
import { providePrimeNG } from 'primeng/config';
import { defaultTranslation } from '../config/PrimeNgTranslation.utils';

export const providePrimeNg = () =>
  providePrimeNG({
    translation: defaultTranslation,
    theme: {
      preset: definePreset(Lara, {
        semantic: {
          primary: {
            50: '#006436',
            100: '#006436',
            200: '#006436',
            300: '#006436',
            400: '#006436',
            500: '#006436',
            600: '#006436',
            700: '#006436',
            800: '#006436',
            900: '#006436',
            950: '#006436',
          },
        },
      }),
      options: {
        darkModeSelector: false,
        cssLayer: {
          name: 'primeng',
          order: 'theme, base, primeng',
        },
      },
    },
  });
